import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {ChatMessageThread} from 'llm/chat-library/ChatMessageThread';
import {ClientDisplayChatEvent} from 'llm/chat-library/messages/MessageTypes';
import {LatestUserMessageInfo} from 'llm/ChatScrollTypes';
import {ProgressData} from 'llm/deep-research/messages/DeepResearchProgress';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

export interface DeepResearchMessageThreadProps {
  chatSessionId: string;
  isLoading: boolean;
  messages: Array<ClientDisplayChatEvent>;
  progressData: ProgressData | null;
  openActivityModal: (activityData: ProgressData, selectedToolId?: string) => void;
  onUpdateLatestUserMessageInfo?: ((info: LatestUserMessageInfo) => void) | null;
}

export function DeepResearchMessageThread({
  chatSessionId,
  messages,
  progressData,
  openActivityModal,
  onUpdateLatestUserMessageInfo,
  isLoading,
}: DeepResearchMessageThreadProps): JSX.Element {
  if (isLoading && messages.length === 0) {
    return (
      <CenteredHorizontalThrobber
        {...getTestProps({component: 'DeepResearchMessageThread', element: 'loading-throbber'})}
      />
    );
  }
  return (
    <ChatMessageThread
      events={messages}
      progressData={progressData}
      onUpdateLatestUserMessageInfo={onUpdateLatestUserMessageInfo}
      chatSessionId={chatSessionId}
      actionButton={null}
      readonly={false}
    />
  );
}
